import { axios } from 'lib/axios';

export const verifyOtpAndLogin = (data) => {
  return axios.post('/auth/otp', data);
};
